import React from 'react'
import './quotation.css'
import logoSSL from '../../assets/images/quotation/ssl_img_80x40.webp'
import logoPDP from '../../assets/images/quotation/pdp_img_80x40.webp'
import TestimonialsSwiperCarousel from '../testimonials/testimonials.swiper.carousel'
import testimonialsData from '../testimonials/testimonials.data'

export default function QuotationHeader(props) {
    const { title, message, language, savedPersonalData } = props
    const { testimonialsTextSeller } = testimonialsData

    return (
        <div className={'text-center'}>
            <h1>{title}</h1>
            {!savedPersonalData ? (
                <>
                    <h2 className="quotation_page_subtitle quotation_paragraphs">
                        {message.quotationParagraph01}
                    </h2>

                    <div className='quotation_paragraphs'>
                        <p>{message.quotationParagraph02}</p>
                        <p>{message.quotationParagraph03}</p>
                    </div>
                    <div className="grid gap-4 grid-cols-2">
                        <div className="div_img">
                            <img
                                src={logoSSL}
                                alt="logo SSL"
                                className="logo_img"
                            />
                        </div>
                        <div className="div_img">
                            <img
                                src={logoPDP}
                                alt="logo PDP"
                                className="logo_img"
                            />
                        </div>
                    </div>
                    <div className="quotation-section-cards mt-5">
                        <div className="section-title text-center testimonial-custom-title">
                            <h3>{message.quotationTestimonies}</h3>
                        </div>
                        <div className="carousel">
                            <TestimonialsSwiperCarousel customClassName={"py-3"} data={testimonialsTextSeller} effect={'coverflow'} slidesPerView={'auto'} autoplay={true} initialSlide={Math.floor(testimonialsTextSeller.length / 2)} />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <h2 className="quotation_page_subtitle quotation_paragraphs">
                        {message.pgBusinessForm01}
                    </h2>

                    <div className='quotation_paragraphs'>
                        <p>{message.pgBusinessForm02}</p>
                        <p>{message.pgBusinessForm03}</p>
                    </div>
                </>
            )}
        </div>
    )
}
